import React, {useState} from 'react';
import PropTypes from 'prop-types';
import DropDown from "./DropDown";
import {Icon, IconButton, makeStyles, Tooltip} from "@material-ui/core";
import PopupScreen from "../../../Components/JsonScreen/PopupScreen";
import {useSelector} from "react-redux";
import {multiLanguageValue} from "../../../Components/JsonScreen/Utils/lib";
import {getParamsFromString} from "../../../Components/JsonScreen/Utils";
import {FieldWrapperContext} from "./FieldWrapperContext";
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

const useStyles = makeStyles({
    fieldWrapper: {
        //   width: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        position: 'relative'
    },
    fieldLabel: {
        flex: 'none',
        display: 'block',
    }
});
const FieldWrapper = (props) => {
    const [open, setOpen] = useState(false);
    const [isOpenCreate, setIsOpenCreate] = useState(false);
    const [keyPressed, setKeyPressed] = useState({keyPressed: 0, direction: ''});
    const classes = useStyles();
    const {
        setValue, setFreeSolo,
        setDropdownState, dropdown, focusNow, goBack,
        setInitialValue, changed: changedV, filterValue, path,
        record, fieldRef, showLabel, disabled, labelStyles, fieldStyles,
        label, history, dropdownStyles, required, children, helpText, doActions,
        isMobile, isHidden, globalValues, screenName, dropdownContext, fieldValue,
        dropdownProps: {
            restrictCreate,
            createScreen,
            setCreatedRecord,
            entity
        }
    } = props;

    const {userLanguage} = useSelector(state => state.app);
    const multiLanguageLabel = multiLanguageValue(label, userLanguage)
    const labelValue = globalValues && screenName ? getParamsFromString(multiLanguageLabel, globalValues, screenName) : multiLanguageLabel
    const multiLanguageHelpText = multiLanguageValue(helpText, userLanguage)
    const labelShouldRender = fieldStyles.presentation !== 'standard' && !isMobile && !showLabel && !fieldStyles.hideLabel;
    const onChangeFromDropDown = (event) => {
        const {value} = event.target;
        setValue(value);
        setOpen(false);
        setFreeSolo(false);
        setDropdownState(false)
    };

    const onKeyDownWrapper = (e) => {
        e.stopPropagation();
        const isTyping = e.key.length === 1 && e.key.match(/[0-9a-zA-Z.-\s/&]/i) && !e.ctrlKey && !e.altKey && !e.shiftKey;
        if (e.key === 'Escape') {
            e.stopPropagation();
            if (changedV) {
                e.preventDefault();
                setInitialValue();
            }
            if (open === false && !focusNow) {
                goBack();
            }
            setOpen(false);
            setFreeSolo(false);
            setDropdownState(false)
        }
        if (dropdown && !isOpenCreate) {
            if (e.key === 'Backspace') {
                setOpen(true);
                setFreeSolo(true);
                setDropdownState(true)
            }

            if (e.altKey && e.key === 'ArrowDown') {
                setOpen(true);
                setFreeSolo(true);
                setDropdownState(true)
            }
            if (e.key === 'ArrowDown') {
                setKeyPressed(prevState => {
                    return {keyPressed: prevState.keyPressed + 1, direction: 'down'}
                });
                e.preventDefault()
            }
            if (e.key === 'ArrowUp') {
                setKeyPressed(prevState => {
                    return {keyPressed: prevState.keyPressed - 1, direction: 'up'}
                });
                e.preventDefault()
            }
            if (e.key === 'Enter' && open) {
                e.stopPropagation();
                e.preventDefault();
                setKeyPressed(prevState => {
                    return {keyPressed: prevState.keyPressed - 1, direction: 'enter'}
                });
            }
            if (isTyping && !open) {
                setOpen(true);
                setFreeSolo(true);
                setDropdownState(true)
            }
        }
    };

    const onClickWrapper = () => {
        if (dropdown && !isOpenCreate && !open) {
            setOpen(true);
            dropdown && setFreeSolo(true);
            setDropdownState(true)
        }
    };

    const onBlurWrapper = () => {
        if (dropdown && open) {
            setOpen(false);
            setFreeSolo(false);
            setDropdownState(false)
        }
    };

    const onFocusWrapper = () => {
        if (dropdown && !isOpenCreate) {
            setOpen(true);
            setFreeSolo(true);
            setDropdownState(true)
        }
    };
    return (

        <div
            className={"sb-field-container"}
            style={{
                width: labelStyles.width === '100%' ? '100%' : fieldStyles.fullWidth ? '100%' : "auto",
                display: isHidden ? 'none' : 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                position: 'relative',
                margin: fieldStyles.margin || !fieldStyles.withoutStyles && '0px 0px 1px 0px'
            }}
            onKeyDown={onKeyDownWrapper}
            //onBlur={onBlurWrapper}
            onFocus={onFocusWrapper}
        >
            <div
                style={{
                    display: 'flex',
                    flexDirection: fieldStyles.presentation === 'stackLabel' ? 'column' : 'row',
                    alignItems: fieldStyles.presentation === 'stackLabel' ? 'start' : 'center',
                    position: 'relative',
                    //padding: isMobile && 5,
                    width: '100%'
                }}
            >
                <div className={classes.fieldWrapper}
                     style={{
                         margin: !fieldStyles.withoutStyles && '1px 0px 1px 0px',
                         alignSelf: labelStyles.alignSelf,
                         width: labelShouldRender ? labelValue ? labelStyles.width : "auto" : "auto"
                     }}
                >
                    {labelShouldRender && (
                        <label
                            className={classes.fieldLabel}
                            style={{
                                ...labelStyles,
                                margin: labelStyles.margin,

                            }}
                        >
                            {labelValue} {required && <span style={{color: 'red'}}>*</span>}
                        </label>
                    )}
                </div>
                <ClickAwayListener onClickAway={onBlurWrapper} mouseEvent={"onMouseDown"}
                >
                    <div onClick={onClickWrapper}
                         style={{width: (isMobile || fieldStyles.fullWidth) ? '100%' : fieldStyles.width}}>
                        <FieldWrapperContext.Provider value={{
                            openDropdown: onClickWrapper,
                            closeDropdown: onBlurWrapper,
                            isOpened: open
                        }}>
                            {children}
                        </FieldWrapperContext.Provider>

                        {!disabled && open && dropdown && (
                            <DropDown anchorEl={fieldRef.current}
                                      dropdownStyles={dropdownStyles}
                                      history={history}
                                      open={open}
                                      keyPressed={keyPressed.keyPressed}
                                      direction={keyPressed.direction}
                                      onClickWrapper={onClickWrapper}
                                      onClose={() => {
                                      }}
                                      setFreeSolo={setFreeSolo}
                                      setFieldValue={onChangeFromDropDown}
                                      record={record[path.split('.')[0]]}
                                      fieldValue={filterValue}
                                      path={path}
                                      dropdownName={dropdown}
                                      inputValue={filterValue}
                                      setValue={setValue}
                                      dropdownProps={{
                                          openCreate: () => {
                                              doActions({
                                                  type: 'openPopup',
                                                  destination: createScreen,
                                                  returnPath: path,
                                                  returnValue: v => {
                                                      if (v.data) {
                                                          setCreatedRecord(v.data.id)
                                                      }

                                                  }
                                              })
                                          },
                                          dropdownContext: dropdownContext,
                                          restrictCreate: entity ? restrictCreate : true,
                                          path,
                                          fieldValue
                                      }}
                            />
                        )}
                    </div>
                </ClickAwayListener>
                {helpText && (
                    <div style={{paddingLeft: 5}}>
                        <Tooltip title={<div dangerouslySetInnerHTML={{__html: multiLanguageHelpText}}/>}>
                            <IconButton size={"small"} color={"primary"}>
                                <Icon fontSize={"small"}>
                                    help_outline
                                </Icon>
                            </IconButton>
                        </Tooltip>
                    </div>
                )}


            </div>
        </div>
    )

};
export default FieldWrapper;

FieldWrapper.propTypes = {
    dropdown: PropTypes.string,
    children: PropTypes.node,
    record: PropTypes.any,
    filterValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    path: PropTypes.string,
    setValue: PropTypes.func,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fieldStyles: PropTypes.object,
    labelStyles: PropTypes.object,
    showLabel: PropTypes.bool,
    setFreeSolo: PropTypes.func,
    setDropdownState: PropTypes.func,
    isHidden: PropTypes.bool,
    dropdownProps: PropTypes.object,
    dropdownContext: PropTypes.any,
};

FieldWrapper.defaultProps = {
    setFreeSolo: () => {
    },
    setDropdownState: () => {
    },
    fieldStyles: {},
    labelStyles: {},
    record: {},
    isHidden: false,
    dropdownProps: {}
};


const CreateNewRecord = (props) => {
    const {
        restrictCreate, isOpenCreate, createScreen,
        entity, setCreatedRecord,
        closeCreatePopup, history
    } = props;
    if (restrictCreate) return <></>;
    if (!isOpenCreate) return <></>;

    return (
        <PopupScreen
            closePopUp={closeCreatePopup}
            screenName={createScreen}
            history={history}
            state={{inParam: {}}}
            inParam={{[entity]: {}}}
            location={{state: {}}}
            match={{
                params: {name: createScreen}
            }}
            returnValue={setCreatedRecord}
        />
    )
};

CreateNewRecord.propTypes = {
    restrictCreate: PropTypes.bool,
    isOpenCreate: PropTypes.bool,
    createScreen: PropTypes.string,
    entity: PropTypes.string,
    setCreatedRecord: PropTypes.func,
    closeCreatePopup: PropTypes.func,
};